import { createContext, useContext, useState, ReactNode } from 'react';

interface HeaderActionContextValue {
  action: ReactNode | null;
  setHeaderAction: (action: ReactNode | null) => void;
}

const HeaderActionContext = createContext<HeaderActionContextValue | null>(null);

export function HeaderActionProvider({ children }: { children: ReactNode }) {
  const [action, setHeaderAction] = useState<ReactNode | null>(null);

  return (
    <HeaderActionContext.Provider value={{ action, setHeaderAction }}>
      {children}
    </HeaderActionContext.Provider>
  );
}

export function useHeaderAction() {
  const context = useContext(HeaderActionContext);
  if (!context) {
    throw new Error('useHeaderAction must be used within a HeaderActionProvider');
  }
  return context;
}
